module.exports = __webpack_public_path__ + "static/media/canada_flag.7c31af3e.svg";